// ADR-0153 — el tile «NPS» en las Unidades del proyecto: el NPS a los 2
// meses de la entrega, con su tasa de respuesta, que abre la pestaña
// Encuestas. Sólo cuando el servidor dice `enabled` (receta con
// encuestas); con menos de 5 respuestas, «—» y «Pocas respuestas».
// Mismo patrón que `CierreKpis`: tiles opcionales inyectadas en el
// kpi-grid del proyecto.
import type { PostventaSurveySummaryResponse } from "@bitacorapro/api-types";
import { KpiTile } from "./KpiTile";
import { npsValor, respuestasHint } from "../lib/postventa/encuestas";

export function EncuestaKpi({
  summary,
  encuestasHref,
}: {
  summary: PostventaSurveySummaryResponse | undefined;
  encuestasHref: string;
}) {
  if (!summary?.enabled) return null;
  const { nps2m } = summary;
  return (
    <KpiTile
      dense
      label="NPS a los 2 meses"
      value={npsValor(nps2m.nps)}
      hint={respuestasHint(nps2m.respondidas, nps2m.enviadas)}
      to={encuestasHref}
    />
  );
}
